import React from 'react';
import { LayoutDashboard, ShoppingBag, ClipboardList, Wallet as WalletIcon, ArrowLeftRight, Users } from 'lucide-react';
import { useAdmin } from '../../context/AdminContext';

export type AdminTabType = 'admin-dashboard' | 'admin-packages' | 'admin-orders' | 'admin-deposits' | 'admin-buybacks' | 'admin-customers';

interface AdminBottomNavProps {
  activeTab: AdminTabType;
  onSelectTab: (tab: AdminTabType) => void;
}

export const AdminBottomNav: React.FC<AdminBottomNavProps> = ({ activeTab, onSelectTab }) => {
  const { pendingOrdersCount, pendingDepositsCount, pendingBuybacksCount } = useAdmin();

  const navItems = [
    {
      id: 'admin-dashboard' as const,
      label: 'Dashboard',
      icon: LayoutDashboard,
      badge: 0,
    },
    {
      id: 'admin-packages' as const,
      label: 'Packages',
      icon: ShoppingBag,
      badge: 0,
    },
    {
      id: 'admin-orders' as const,
      label: 'Orders',
      icon: ClipboardList,
      badge: pendingOrdersCount,
    },
    {
      id: 'admin-deposits' as const,
      label: 'Deposits',
      icon: WalletIcon,
      badge: pendingDepositsCount,
    },
    {
      id: 'admin-buybacks' as const,
      label: 'Airtime',
      icon: ArrowLeftRight,
      badge: pendingBuybacksCount,
    },
    {
      id: 'admin-customers' as const,
      label: 'Users',
      icon: Users,
      badge: 0,
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-surface-card/95 backdrop-blur-md border-t border-plum-border shadow-lg pb-safe">
      <div className="max-w-md mx-auto flex items-center justify-around h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onSelectTab(item.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full py-1 transition-colors touch-target ${
                isActive ? 'text-primary font-semibold' : 'text-plum-muted hover:text-plum-dark'
              }`}
            >
              <div className={`relative p-1 rounded-xl transition ${isActive ? 'bg-primary/15' : ''}`}>
                <Icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : 'stroke-2'}`} />
                {item.badge > 0 && (
                  <span className="absolute -top-1 -right-2 px-1.5 py-0.2 text-[9px] font-bold rounded-full bg-red-500 text-white shadow-xs border-2 border-surface-card">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className="text-[11px] mt-0.5 leading-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
